import * as ambassadorWixStoresCatalogV3CatalogImport from './stores-catalog-v3-catalog-import-catalog-imports-v-3.http.js';
import * as ambassadorWixStoresCatalogV3CatalogImportTypes from './stores-catalog-v3-catalog-import-catalog-imports-v-3.types.js';
import * as ambassadorWixStoresCatalogV3CatalogImportUniversalTypes from './stores-catalog-v3-catalog-import-catalog-imports-v-3.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createCatalogImport(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresCatalogV3CatalogImportUniversalTypes.CreateCatalogImportRequest,
  ambassadorWixStoresCatalogV3CatalogImportTypes.CreateCatalogImportRequest,
  ambassadorWixStoresCatalogV3CatalogImportUniversalTypes.CreateCatalogImportResponse,
  ambassadorWixStoresCatalogV3CatalogImportTypes.CreateCatalogImportResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3CatalogImport.createCatalogImport(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/catalog-imports',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addProductsToImport(): __PublicMethodMetaInfo<
  'POST',
  { catalogImportId: string },
  ambassadorWixStoresCatalogV3CatalogImportUniversalTypes.AddProductsToImportRequest,
  ambassadorWixStoresCatalogV3CatalogImportTypes.AddProductsToImportRequest,
  ambassadorWixStoresCatalogV3CatalogImportUniversalTypes.AddProductsToImportResponse,
  ambassadorWixStoresCatalogV3CatalogImportTypes.AddProductsToImportResponse
> {
  const payload = { catalogImportId: ':catalogImportId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3CatalogImport.addProductsToImport(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/catalog-imports/{catalogImportId}/add-products',
    pathParams: { catalogImportId: 'catalogImportId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function submitCatalogImport(): __PublicMethodMetaInfo<
  'POST',
  { catalogImportId: string },
  ambassadorWixStoresCatalogV3CatalogImportUniversalTypes.SubmitCatalogImportRequest,
  ambassadorWixStoresCatalogV3CatalogImportTypes.SubmitCatalogImportRequest,
  ambassadorWixStoresCatalogV3CatalogImportUniversalTypes.SubmitCatalogImportResponse,
  ambassadorWixStoresCatalogV3CatalogImportTypes.SubmitCatalogImportResponse
> {
  const payload = { catalogImportId: ':catalogImportId' } as any;

  const getRequestOptions =
    ambassadorWixStoresCatalogV3CatalogImport.submitCatalogImport(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/catalog-imports/{catalogImportId}/submit',
    pathParams: { catalogImportId: 'catalogImportId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CatalogImport as CatalogImportOriginal,
  CreateCatalogImportRequest as CreateCatalogImportRequestOriginal,
  CreateCatalogImportResponse as CreateCatalogImportResponseOriginal,
  AddProductsToImportRequest as AddProductsToImportRequestOriginal,
  ProductItem as ProductItemOriginal,
  ProductWithInventory as ProductWithInventoryOriginal,
  ProductWithInventoryTypedPropertiesOneOf as ProductWithInventoryTypedPropertiesOneOfOriginal,
  RichContent as RichContentOriginal,
  Node as NodeOriginal,
  NodeDataOneOf as NodeDataOneOfOriginal,
  NodeType as NodeTypeOriginal,
  NodeTypeWithLiterals as NodeTypeWithLiteralsOriginal,
  NodeStyle as NodeStyleOriginal,
  ButtonData as ButtonDataOriginal,
  BackgroundType as BackgroundTypeOriginal,
  BackgroundTypeWithLiterals as BackgroundTypeWithLiteralsOriginal,
  Gradient as GradientOriginal,
  GradientType as GradientTypeOriginal,
  GradientTypeWithLiterals as GradientTypeWithLiteralsOriginal,
  Stop as StopOriginal,
  Border as BorderOriginal,
  Colors as ColorsOriginal,
  Background as BackgroundOriginal,
  PluginContainerData as PluginContainerDataOriginal,
  WidthType as WidthTypeOriginal,
  WidthTypeWithLiterals as WidthTypeWithLiteralsOriginal,
  PluginContainerDataWidth as PluginContainerDataWidthOriginal,
  PluginContainerDataWidthDataOneOf as PluginContainerDataWidthDataOneOfOriginal,
  PluginContainerDataAlignment as PluginContainerDataAlignmentOriginal,
  PluginContainerDataAlignmentWithLiterals as PluginContainerDataAlignmentWithLiteralsOriginal,
  Spoiler as SpoilerOriginal,
  Height as HeightOriginal,
  ButtonDataType as ButtonDataTypeOriginal,
  ButtonDataTypeWithLiterals as ButtonDataTypeWithLiteralsOriginal,
  Styles as StylesOriginal,
  Link as LinkOriginal,
  LinkDataOneOf as LinkDataOneOfOriginal,
  Target as TargetOriginal,
  TargetWithLiterals as TargetWithLiteralsOriginal,
  Rel as RelOriginal,
  CodeBlockData as CodeBlockDataOriginal,
  TextStyle as TextStyleOriginal,
  TextAlignment as TextAlignmentOriginal,
  TextAlignmentWithLiterals as TextAlignmentWithLiteralsOriginal,
  DividerData as DividerDataOriginal,
  LineStyle as LineStyleOriginal,
  LineStyleWithLiterals as LineStyleWithLiteralsOriginal,
  Width as WidthOriginal,
  WidthWithLiterals as WidthWithLiteralsOriginal,
  DividerDataAlignment as DividerDataAlignmentOriginal,
  DividerDataAlignmentWithLiterals as DividerDataAlignmentWithLiteralsOriginal,
  FileData as FileDataOriginal,
  ViewMode as ViewModeOriginal,
  ViewModeWithLiterals as ViewModeWithLiteralsOriginal,
  FileSource as FileSourceOriginal,
  FileSourceDataOneOf as FileSourceDataOneOfOriginal,
  PDFSettings as PDFSettingsOriginal,
  GalleryData as GalleryDataOriginal,
  V1Media as V1MediaOriginal,
  ItemImage as ItemImageOriginal,
  Video as VideoOriginal,
  Item as ItemOriginal,
  ItemDataOneOf as ItemDataOneOfOriginal,
  GalleryOptions as GalleryOptionsOriginal,
  LayoutType as LayoutTypeOriginal,
  LayoutTypeWithLiterals as LayoutTypeWithLiteralsOriginal,
  Orientation as OrientationOriginal,
  OrientationWithLiterals as OrientationWithLiteralsOriginal,
  Crop as CropOriginal,
  CropWithLiterals as CropWithLiteralsOriginal,
  ThumbnailsAlignment as ThumbnailsAlignmentOriginal,
  ThumbnailsAlignmentWithLiterals as ThumbnailsAlignmentWithLiteralsOriginal,
  GalleryOptionsLayout as GalleryOptionsLayoutOriginal,
  ItemStyle as ItemStyleOriginal,
  Thumbnails as ThumbnailsOriginal,
  GIFData as GIFDataOriginal,
  GIF as GIFOriginal,
  GIFType as GIFTypeOriginal,
  GIFTypeWithLiterals as GIFTypeWithLiteralsOriginal,
  HeadingData as HeadingDataOriginal,
  HTMLData as HTMLDataOriginal,
  HTMLDataDataOneOf as HTMLDataDataOneOfOriginal,
  Source as SourceOriginal,
  SourceWithLiterals as SourceWithLiteralsOriginal,
  ImageData as ImageDataOriginal,
  StylesBorder as StylesBorderOriginal,
  ImageDataStyles as ImageDataStylesOriginal,
  LinkPreviewData as LinkPreviewDataOriginal,
  StylesPosition as StylesPositionOriginal,
  StylesPositionWithLiterals as StylesPositionWithLiteralsOriginal,
  LinkPreviewDataStyles as LinkPreviewDataStylesOriginal,
  MapData as MapDataOriginal,
  MapSettings as MapSettingsOriginal,
  MapType as MapTypeOriginal,
  MapTypeWithLiterals as MapTypeWithLiteralsOriginal,
  ParagraphData as ParagraphDataOriginal,
  PollData as PollDataOriginal,
  ViewRole as ViewRoleOriginal,
  ViewRoleWithLiterals as ViewRoleWithLiteralsOriginal,
  VoteRole as VoteRoleOriginal,
  VoteRoleWithLiterals as VoteRoleWithLiteralsOriginal,
  Permissions as PermissionsOriginal,
  Option as OptionOriginal,
  PollSettings as PollSettingsOriginal,
  PollLayoutType as PollLayoutTypeOriginal,
  PollLayoutTypeWithLiterals as PollLayoutTypeWithLiteralsOriginal,
  PollLayoutDirection as PollLayoutDirectionOriginal,
  PollLayoutDirectionWithLiterals as PollLayoutDirectionWithLiteralsOriginal,
  PollLayout as PollLayoutOriginal,
  OptionLayout as OptionLayoutOriginal,
  PollDesignBackgroundType as PollDesignBackgroundTypeOriginal,
  PollDesignBackgroundTypeWithLiterals as PollDesignBackgroundTypeWithLiteralsOriginal,
  BackgroundGradient as BackgroundGradientOriginal,
  PollDesignBackground as PollDesignBackgroundOriginal,
  PollDesignBackgroundBackgroundOneOf as PollDesignBackgroundBackgroundOneOfOriginal,
  PollDesign as PollDesignOriginal,
  OptionDesign as OptionDesignOriginal,
  Poll as PollOriginal,
  PollDataLayout as PollDataLayoutOriginal,
  Design as DesignOriginal,
  TextData as TextDataOriginal,
  Decoration as DecorationOriginal,
  DecorationDataOneOf as DecorationDataOneOfOriginal,
  DecorationType as DecorationTypeOriginal,
  DecorationTypeWithLiterals as DecorationTypeWithLiteralsOriginal,
  AnchorData as AnchorDataOriginal,
  ColorData as ColorDataOriginal,
  LinkData as LinkDataOriginal,
  MentionData as MentionDataOriginal,
  FontSizeData as FontSizeDataOriginal,
  FontType as FontTypeOriginal,
  FontTypeWithLiterals as FontTypeWithLiteralsOriginal,
  SpoilerData as SpoilerDataOriginal,
  FontFamilyData as FontFamilyDataOriginal,
  SketchData as SketchDataOriginal,
  Variant as VariantOriginal,
  VariantWithLiterals as VariantWithLiteralsOriginal,
  AppEmbedData as AppEmbedDataOriginal,
  AppEmbedDataAppDataOneOf as AppEmbedDataAppDataOneOfOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  AspectRatio as AspectRatioOriginal,
  AspectRatioWithLiterals as AspectRatioWithLiteralsOriginal,
  Resizing as ResizingOriginal,
  ResizingWithLiterals as ResizingWithLiteralsOriginal,
  Placement as PlacementOriginal,
  PlacementWithLiterals as PlacementWithLiteralsOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Alignment as AlignmentOriginal,
  AlignmentWithLiterals as AlignmentWithLiteralsOriginal,
  Layout as LayoutOriginal,
  LayoutWithLiterals as LayoutWithLiteralsOriginal,
  AppType as AppTypeOriginal,
  AppTypeWithLiterals as AppTypeWithLiteralsOriginal,
  BookingData as BookingDataOriginal,
  EventData as EventDataOriginal,
  ButtonStyles as ButtonStylesOriginal,
  ImageStyles as ImageStylesOriginal,
  RibbonStyles as RibbonStylesOriginal,
  CardStyles as CardStylesOriginal,
  PricingData as PricingDataOriginal,
  VideoData as VideoDataOriginal,
  PlaybackOptions as PlaybackOptionsOriginal,
  EmbedData as EmbedDataOriginal,
  Oembed as OembedOriginal,
  CollapsibleListData as CollapsibleListDataOriginal,
  InitialExpandedItems as InitialExpandedItemsOriginal,
  InitialExpandedItemsWithLiterals as InitialExpandedItemsWithLiteralsOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  TableData as TableDataOriginal,
  TableDataDimensions as TableDataDimensionsOriginal,
  TableCellData as TableCellDataOriginal,
  VerticalAlignment as VerticalAlignmentOriginal,
  VerticalAlignmentWithLiterals as VerticalAlignmentWithLiteralsOriginal,
  CellStyle as CellStyleOriginal,
  BorderColors as BorderColorsOriginal,
  BorderWidths as BorderWidthsOriginal,
  NullValue as NullValueOriginal,
  NullValueWithLiterals as NullValueWithLiteralsOriginal,
  ListValue as ListValueOriginal,
  AudioData as AudioDataOriginal,
  OrderedListData as OrderedListDataOriginal,
  BulletedListData as BulletedListDataOriginal,
  BlockquoteData as BlockquoteDataOriginal,
  CaptionData as CaptionDataOriginal,
  LayoutData as LayoutDataOriginal,
  ImageScalingScaling as ImageScalingScalingOriginal,
  ImageScalingScalingWithLiterals as ImageScalingScalingWithLiteralsOriginal,
  ImagePosition as ImagePositionOriginal,
  ImagePositionWithLiterals as ImagePositionWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  BannerPosition as BannerPositionOriginal,
  BannerPositionWithLiterals as BannerPositionWithLiteralsOriginal,
  LayoutDataBackgroundType as LayoutDataBackgroundTypeOriginal,
  LayoutDataBackgroundTypeWithLiterals as LayoutDataBackgroundTypeWithLiteralsOriginal,
  BackdropType as BackdropTypeOriginal,
  BackdropTypeWithLiterals as BackdropTypeWithLiteralsOriginal,
  LayoutDataBackgroundImage as LayoutDataBackgroundImageOriginal,
  VerticalAlignmentAlignment as VerticalAlignmentAlignmentOriginal,
  VerticalAlignmentAlignmentWithLiterals as VerticalAlignmentAlignmentWithLiteralsOriginal,
  ResponsivenessBehaviour as ResponsivenessBehaviourOriginal,
  ResponsivenessBehaviourWithLiterals as ResponsivenessBehaviourWithLiteralsOriginal,
  DesignTarget as DesignTargetOriginal,
  DesignTargetWithLiterals as DesignTargetWithLiteralsOriginal,
  Banner as BannerOriginal,
  LayoutDataBackground as LayoutDataBackgroundOriginal,
  Backdrop as BackdropOriginal,
  LayoutCellData as LayoutCellDataOriginal,
  ShapeData as ShapeDataOriginal,
  ShapeDataStyles as ShapeDataStylesOriginal,
  CardData as CardDataOriginal,
  Scaling as ScalingOriginal,
  ScalingWithLiterals as ScalingWithLiteralsOriginal,
  ImagePositionPosition as ImagePositionPositionOriginal,
  ImagePositionPositionWithLiterals as ImagePositionPositionWithLiteralsOriginal,
  CardDataBackgroundType as CardDataBackgroundTypeOriginal,
  CardDataBackgroundTypeWithLiterals as CardDataBackgroundTypeWithLiteralsOriginal,
  CardDataBackground as CardDataBackgroundOriginal,
  BackgroundImage as BackgroundImageOriginal,
  TocData as TocDataOriginal,
  ListStyle as ListStyleOriginal,
  ListStyleWithLiterals as ListStyleWithLiteralsOriginal,
  Indentation as IndentationOriginal,
  IndentationWithLiterals as IndentationWithLiteralsOriginal,
  SmartBlockData as SmartBlockDataOriginal,
  SmartBlockDataType as SmartBlockDataTypeOriginal,
  SmartBlockDataTypeWithLiterals as SmartBlockDataTypeWithLiteralsOriginal,
  ColumnSize as ColumnSizeOriginal,
  ColumnSizeWithLiterals as ColumnSizeWithLiteralsOriginal,
  SmartBlockCellData as SmartBlockCellDataOriginal,
  CheckboxListData as CheckboxListDataOriginal,
  ListItemNodeData as ListItemNodeDataOriginal,
  Metadata as MetadataOriginal,
  DocumentStyle as DocumentStyleOriginal,
  TextNodeStyle as TextNodeStyleOriginal,
  Media as MediaOriginal,
  ProductMedia as ProductMediaOriginal,
  ProductMediaSetByOneOf as ProductMediaSetByOneOfOriginal,
  ProductMediaMediaOneOf as ProductMediaMediaOneOfOriginal,
  Image as ImageOriginal,
  VideoV2 as VideoV2Original,
  VideoResolution as VideoResolutionOriginal,
  MediaType as MediaTypeOriginal,
  MediaTypeWithLiterals as MediaTypeWithLiteralsOriginal,
  Thumbnail as ThumbnailOriginal,
  MediaItemsInfo as MediaItemsInfoOriginal,
  SeoSchema as SeoSchemaOriginal,
  Keyword as KeywordOriginal,
  Tag as TagOriginal,
  Settings as SettingsOriginal,
  ConnectedOption as ConnectedOptionOriginal,
  ConnectedOptionOptionSettingsOneOf as ConnectedOptionOptionSettingsOneOfOriginal,
  ProductOptionRenderType as ProductOptionRenderTypeOriginal,
  ProductOptionRenderTypeWithLiterals as ProductOptionRenderTypeWithLiteralsOriginal,
  ChoicesSettings as ChoicesSettingsOriginal,
  ConnectedOptionChoice as ConnectedOptionChoiceOriginal,
  ConnectedOptionChoiceValueOneOf as ConnectedOptionChoiceValueOneOfOriginal,
  ChoiceType as ChoiceTypeOriginal,
  ChoiceTypeWithLiterals as ChoiceTypeWithLiteralsOriginal,
  MultipleColors as MultipleColorsOriginal,
  MediaReferences as MediaReferencesOriginal,
  MediaReference as MediaReferenceOriginal,
  MediaReferenceIdentifierOneOf as MediaReferenceIdentifierOneOfOriginal,
  ConnectedModifier as ConnectedModifierOriginal,
  ConnectedModifierModifierSettingsOneOf as ConnectedModifierModifierSettingsOneOfOriginal,
  ModifierRenderType as ModifierRenderTypeOriginal,
  ModifierRenderTypeWithLiterals as ModifierRenderTypeWithLiteralsOriginal,
  FreeTextSettings as FreeTextSettingsOriginal,
  ModifierChoicesSettings as ModifierChoicesSettingsOriginal,
  ConnectedModifierChoice as ConnectedModifierChoiceOriginal,
  ConnectedModifierChoiceValueOneOf as ConnectedModifierChoiceValueOneOfOriginal,
  Brand as BrandOriginal,
  InfoSection as InfoSectionOriginal,
  Ribbon as RibbonOriginal,
  ProductType as ProductTypeOriginal,
  ProductTypeWithLiterals as ProductTypeWithLiteralsOriginal,
  PhysicalProperties as PhysicalPropertiesOriginal,
  PricePerUnitSettings as PricePerUnitSettingsOriginal,
  MeasurementUnit as MeasurementUnitOriginal,
  MeasurementUnitWithLiterals as MeasurementUnitWithLiteralsOriginal,
  WeightRange as WeightRangeOriginal,
  PricePerUnitRange as PricePerUnitRangeOriginal,
  PricePerUnitRangePricePerUnit as PricePerUnitRangePricePerUnitOriginal,
  WeightMeasurementUnitInfo as WeightMeasurementUnitInfoOriginal,
  WeightUnit as WeightUnitOriginal,
  WeightUnitWithLiterals as WeightUnitWithLiteralsOriginal,
  VariantsInfo as VariantsInfoOriginal,
  VariantWithInventory as VariantWithInventoryOriginal,
  VariantWithInventoryTypedPropertiesOneOf as VariantWithInventoryTypedPropertiesOneOfOriginal,
  PriceInfo as PriceInfoOriginal,
  FixedMonetaryAmount as FixedMonetaryAmountOriginal,
  RevenueDetails as RevenueDetailsOriginal,
  VariantPhysicalProperties as VariantPhysicalPropertiesOriginal,
  PricePerUnit as PricePerUnitOriginal,
  Dimensions as DimensionsOriginal,
  DimensionsUnit as DimensionsUnitOriginal,
  DimensionsUnitWithLiterals as DimensionsUnitWithLiteralsOriginal,
  VariantDigitalProperties as VariantDigitalPropertiesOriginal,
  SecuredMedia as SecuredMediaOriginal,
  FileType as FileTypeOriginal,
  FileTypeWithLiterals as FileTypeWithLiteralsOriginal,
  InventoryItemComposite as InventoryItemCompositeOriginal,
  InventoryItemCompositeTrackingMethodOneOf as InventoryItemCompositeTrackingMethodOneOfOriginal,
  PreorderInfo as PreorderInfoOriginal,
  OptionChoiceReferences as OptionChoiceReferencesOriginal,
  OptionChoiceIds as OptionChoiceIdsOriginal,
  OptionChoiceNames as OptionChoiceNamesOriginal,
  SubscriptionDetails as SubscriptionDetailsOriginal,
  Subscription as SubscriptionOriginal,
  SubscriptionCyclesOneOf as SubscriptionCyclesOneOfOriginal,
  SubscriptionFrequency as SubscriptionFrequencyOriginal,
  SubscriptionFrequencyWithLiterals as SubscriptionFrequencyWithLiteralsOriginal,
  SubscriptionDiscount as SubscriptionDiscountOriginal,
  SubscriptionDiscountDiscountOneOf as SubscriptionDiscountDiscountOneOfOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  PurchaseEligibility as PurchaseEligibilityOriginal,
  UserCriteria as UserCriteriaOriginal,
  UserCriteriaWithLiterals as UserCriteriaWithLiteralsOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  ProductCategoryIdsInfo as ProductCategoryIdsInfoOriginal,
  AddProductsToImportResponse as AddProductsToImportResponseOriginal,
  AddProductResult as AddProductResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  SubmitCatalogImportRequest as SubmitCatalogImportRequestOriginal,
  SubmitCatalogImportResponse as SubmitCatalogImportResponseOriginal,
  CatalogImportAlreadySubmittedErrorData as CatalogImportAlreadySubmittedErrorDataOriginal,
  QueryProductItemsInImportRequest as QueryProductItemsInImportRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryProductItemsInImportResponse as QueryProductItemsInImportResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  SubmitCatalogImportApplicationErrors as SubmitCatalogImportApplicationErrorsOriginal,
} from './stores-catalog-v3-catalog-import-catalog-imports-v-3.types.js';
